import { Component } from "@angular/core";
import { CustomModal } from "../../../../core/components/base-modals";
import { Helper } from "@helpers/functions";
import { InvitationService } from "@main-services/invitation.service";

@Component({
	templateUrl: "./contact-add-success.component.html",
	styleUrls: ["./contact-add-success.component.scss"],
	standalone: false
})
export class ContactAddSuccessComponent extends CustomModal {
	private _isInvited: boolean = false;
	public inviteButtonText: string = "send_invitation_taf";

	public constructor(private tafService: InvitationService) {
		super();
	}

	public getContactName(): string {
		return this.data.getName();
	}

	public hasEmailAddress(): boolean {
		return this.data.getFields().some((field) => field.getType() === "email" && !!field.getValue());
	}

	public isInvited(): boolean {
		return this._isInvited;
	}

	public invite(): void {
		this.tafService.taf.email = this.data.getEmail();
		this.tafService.tellAFriend().subscribe(
			() => this.startButtonTimer(),
			(e) => Helper.handleError(e, this.data)
		);
	}

	public startButtonTimer(): void {
		this.inviteButtonText = "sending_invite_contacts";
		let time: number = 3;
		const timer = window.setInterval(() => {
			if (--time <= 0) {
				clearInterval(timer);
				if (!this.data.hasError("email")) {
					this._isInvited = true;
					this.inviteButtonText = "invite_more_contacts";
				}
			}
		}, 1000);
	}
}
